import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { hallSaveOrUpdate } from "@/api/managementCenter/navlink";
import cropperImg from "@/components/common/cropperImg.vue";
import { sysFileUpload, sysFileDelete, getRoleList } from "@/api/managementCenter/otherApi";
import { remote } from "@/api/admin/dict";
export default {
  name: "AppDialog",
  components: {
    cropperImg: cropperImg
  },
  props: [],
  data: function data() {
    var validateUrl = function validateUrl(rule, value, callback) {
      var url_pattern = new RegExp("((ftp|http|https)(://))?([a-zA-Z0-9]+[.]{1}){2}[a-zA-z0-9]+(/{1}[a-zA-Z0-9]+)*/?", "i");

      if (value == "") {
        callback(new Error("请输入链接地址"));
      } else if (!url_pattern.test(value)) {
        callback(new Error("请输入正确的链接地址"));
      } else {
        callback();
      }
    };

    return {
      imgSrc: "",
      show: false,
      loading: false,
      title: "",
      fileList: [],
      form: {
        name: "",
        url: "",
        imageUrl: "",
        type: null,
        id: "",
        roleType: ""
      },
      rules: {
        name: [{
          required: true,
          message: "请输入应用名称",
          trigger: "blur"
        }],
        type: [{
          required: true,
          message: "请选择应用类型",
          trigger: "change"
        }],
        imageUrl: [{
          required: true,
          message: "请上传应用图标",
          trigger: "change"
        }],
        url: [{
          validator: validateUrl,
          trigger: "blur"
        }] // roleList: [
        //     { required: true, message: "请选择应用角色对象", trigger: "change" }
        // ],

      },
      options: [],
      roleList: [],
      roleSelect: []
    };
  },
  computed: {},
  mounted: function mounted() {
    this.getSelData();
    this.getRoleListData();
  },
  methods: {
    //获取类型
    getSelData: function getSelData() {
      var _this = this;

      remote("navlink_list").then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this.options = data.data || [];
        } else {
          _this.$message.warning(data.msg || "获取类型失败!");
        }
      }).catch(function (err) {
        _this.$message.error(err.msg || "获取类型异常!");
      });
    },
    // 显示弹框
    dialogShow: function dialogShow(type, data) {
      // 重置表单、显示弹框
      this.show = true;
      this.$nextTick(function () {
        this.$refs["ruleForm"].resetFields();

        switch (type) {
          case "add":
            this.title = "新增导航";
            this.fileList = [];
            this.form = {
              id: "",
              type: null,
              imageUrl: "",
              name: "",
              url: "",
              roleType: ""
            };
            break;

          case "edit":
            this.title = "编辑导航";
            this.form = {
              id: data.id,
              name: data.name,
              url: data.url,
              imageUrl: "",
              type: data.type,
              roleType: data.roleType
            };
            this.roleSelect = data.roleType.split(",");
            this.fileList = [{
              id: "",
              url: data.imageUrl
            }];
            break;
        }
      });
    },
    saveOrUpdate: function saveOrUpdate() {
      var _this2 = this;

      this.form.roleType = this.roleSelect.join(",");
      this.loading = true;
      hallSaveOrUpdate(this.form).then(function (_ref2) {
        var data = _ref2.data;
        _this2.loading = false;

        if (data.code == 0) {
          _this2.$message.success("保存成功!");

          _this2.show = false;

          _this2.$emit("saveSuccess");
        } else {
          _this2.$message.warning(data.msg || "保存失败!");
        }

        _this2.roleSelect = [];
      }).catch(function (err) {
        _this2.loading = false;

        _this2.$message.error("服务器异常!");
      });
    },
    // 确定提交
    submitForm: function submitForm(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.saveOrUpdate();
        } else {
          return false;
        }
      });
    },
    handleRemove: function handleRemove() {
      // this.deleteFile(this.fileList[0].id)
      this.fileList = [];
    },
    deleteFile: function deleteFile(id) {
      var _this4 = this;

      sysFileDelete(id).then(function (_ref3) {
        var data = _ref3.data;

        if (data.code == 0) {
          _this4.$message.success("删除成功!");
        } else {
          _this4.$message.warning(data.msg || "删除失败！");
        }
      }).catch(function (err) {
        _this4.$message.error("删除异常!");
      });
    },
    uploadHttp: function uploadHttp(file) {
      var _this5 = this;

      var fd = new FormData();
      fd.append("fromTarget", 1);
      fd.append("file", file); //上传到后台

      this.loading = true;
      sysFileUpload(fd).then(function (_ref4) {
        var data = _ref4.data;
        _this5.loading = false;

        if (data.code == 0) {
          _this5.$refs.cropperImg.closeDialog();

          _this5.$message.success("上传文件成功!");

          _this5.fileList.push(_objectSpread({}, data.data));
        } else {
          _this5.$message.warning(data.msg || "上传文件失败!");
        }
      }).catch(function (err) {
        _this5.loading = false;

        _this5.$message.error("上传文件异常!");
      });
    },
    // 上传文件之前的方法
    handleBeforeUpload: function handleBeforeUpload(file) {
      if (this.fileList.length > 0) {
        return this.$message.error("只能上传一张应用图标！");
      }

      this.$refs.cropperImg.uploadImg(file);
      return;
    },
    handlePreview: function handlePreview() {
      window.location.href = this.fileList[0].url;
    },
    //获取角色列表
    getRoleListData: function getRoleListData() {
      var _this6 = this;

      getRoleList().then(function (_ref5) {
        var data = _ref5.data;

        if (data.code == 0) {
          _this6.roleList = data.data.map(function (i) {
            return _objectSpread(_objectSpread({}, i), {}, {
              roleId: i.roleId + ""
            });
          });
        }
      }).catch(function (err) {});
    },
    dialogClose: function dialogClose() {
      this.roleSelect = [];
    }
  },
  watch: {
    fileList: function fileList(value) {
      if (value.length) {
        this.form.imageUrl = value[0].url;
      } else {
        this.form.imageUrl = "";
      }
    }
  },
  filters: {}
};